export const FOUNDATION = 'The Foundation'
export const PL_DECLINED = 'Declined PL - Foundation'
